import { render, staticRenderFns } from "./NewProducts.vue?vue&type=template&id=1cf7900c&"
import script from "./NewProducts.vue?vue&type=script&lang=js&"
export * from "./NewProducts.vue?vue&type=script&lang=js&"
import style0 from "./NewProducts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports